import styled from 'styled-components';

export const Wrapper = styled.div`
  position: fixed;
  bottom: 15rem;
  right: 0;
  z-index: 99;
`;
